<script>
	import { publishTitle } from '../../stores/publish/PublishStore';
	import { seoOgIsActive, seoOgTwitterTitle } from '../../stores/seo/SeoStore';
	import { updateSeoOgTwitterTitle } from '../../stores/seo/UpdateSeoOgTwitterTitle';

	let publishTitleValue;
	let seoOgIsActiveValue;
	let seoOgTwitterTitleValue;

	seoOgIsActive.subscribe((value) => {
		seoOgIsActiveValue = value;
		if (!seoOgIsActiveValue) {
			updateSeoOgTwitterTitle(publishTitleValue);
		}
	});

	publishTitle.subscribe((value) => {
		publishTitleValue = value;
		if (!seoOgIsActiveValue) {
			updateSeoOgTwitterTitle(publishTitleValue);
		}
	});

	seoOgTwitterTitle.subscribe((value) => {
		seoOgTwitterTitleValue = value;
	});

	const onSeoOgTwitterTitleChange = (event) => updateSeoOgTwitterTitle(event.target.value);
</script>

<div class="proteus-control proteus-group protues-ui-input">
	<label class="proteus-label" for="angle">OG Twitter Title:</label>
	<input class="proteus-input" type="text" name="seoOgTwitterTitle" value={seoOgTwitterTitleValue} on:input={onSeoOgTwitterTitleChange} disabled={!seoOgIsActiveValue} readonly={!seoOgIsActiveValue} />
</div>
